function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { VendorCodes, VendorNames } from '../enums';
var _obj;
var mapper = (_obj = {}, _define_property(_obj, VendorCodes.GW, VendorNames.GW), _define_property(_obj, VendorCodes.PCGL, VendorNames.PCGL), _define_property(_obj, VendorCodes.TSLA, VendorNames.TSLA), _define_property(_obj, VendorCodes.Symbiotic, VendorNames.Symbiotic), _define_property(_obj, VendorCodes.SFTCHE, VendorNames.SFTCHE), _define_property(_obj, VendorCodes.DEMO, VendorNames.DEMO), _define_property(_obj, VendorCodes.IMETHODS, VendorNames.IMETHODS), _define_property(_obj, VendorCodes.DEMOSANDBOX, VendorNames.DEMOSANDBOX), _define_property(_obj, VendorCodes.BridgeView, VendorNames.BridgeView), _define_property(_obj, VendorCodes.Jarvis, VendorNames.Jarvis), _obj);
export var mapVendorCodeToName = function(vendorCode) {
    if (!vendorCode) return vendorCode;
    return mapper[vendorCode];
};
